import { formatDate } from '../helpers/dates';
const updateTariffs = () => {
    const activeRadio = document.querySelector('input[name="tariff_c"]:checked');
    const inactiveRadios = document.querySelectorAll('input[name="tariff_c"]:not(:checked)');
    const notAvailableText24h = document.getElementById('not-available-text-24h');
    const promoText24h = document.getElementById('promo-text-24h');
    const includedText24h = document.getElementById('included-text-24h');
    const checkbox24h = document.getElementById('24h');
    if (activeRadio === null || inactiveRadios.length === 0) {
        return;
    }
    const tariff = activeRadio.value;
    const tariffDetails = window.prices[tariff];
    inactiveRadios.forEach(function (inactiveRadio) {
        if (inactiveRadio.parentElement) {
            inactiveRadio.parentElement.dataset.selected = 'false';
        }
        const descriptionContainer = inactiveRadio.nextElementSibling?.querySelector('.o-collapsable');
        if (descriptionContainer) {
            descriptionContainer.dataset.state = 'closed';
        }
    });
    if (activeRadio.parentElement) {
        activeRadio.parentElement.dataset.selected = 'true';
    }
    const descriptionContainer = activeRadio.nextElementSibling?.querySelector('.o-collapsable');
    if (descriptionContainer) {
        descriptionContainer.dataset.state = 'true';
    }
    if (notAvailableText24h) {
        notAvailableText24h.style.display = tariffDetails.option24hAvailable ? 'none' : 'block';
    }
    if (promoText24h) {
        promoText24h.style.display =
            tariffDetails.option24hAvailable && !tariffDetails.option24hIncluded ? 'block' : 'none';
    }
    if (includedText24h) {
        includedText24h.style.display = tariffDetails.option24hIncluded ? 'block' : 'none';
    }
    if (checkbox24h) {
        checkbox24h.checked = tariffDetails.option24hIncluded;
        checkbox24h.disabled = !tariffDetails.option24hAvailable;
    }
    updateSummary();
};
export const updateSummary = () => {
    const quickOrder = document.querySelector('.c-form--ps-phone-service-order');
    if (!quickOrder) {
        return;
    }
    const selectedTariffOption = quickOrder.querySelector('input[name="tariff_c"]:checked');
    const tariff = (selectedTariffOption ? selectedTariffOption.value : 'smart');
    const tariffDetails = window.prices[tariff];
    const checkbox24h = quickOrder.querySelector('input[name="24h"]');
    const checkboxFax = quickOrder.querySelector('input[name="fax"]');
    const option24h = checkbox24h ? checkbox24h.checked : false;
    const optionFax = checkboxFax ? checkboxFax.checked : false;
    let sum = (window.prices[tariff].monthly || 999) + (optionFax ? window.prices.optionFax || 99 : 0);
    if (!tariffDetails.option24hIncluded && option24h) {
        sum += window.prices.option24h || 99;
    }
    const today = new Date();
    const startPaymentDate = new Date(today.setMonth(today.getMonth() + 1));
    quickOrder.querySelectorAll('.c-product-summary-selected-product').forEach((element) => {
        element.classList.contains('display-' + tariff)
            ? element.classList.remove('u-hidden')
            : element.classList.add('u-hidden');
    });
    const summary24h = quickOrder.querySelector('.summary-24h');
    const summaryPrice24h = document.getElementById('summary-price-24h');
    const summary24hIncluded = document.getElementById('summary-24h-included');
    if (summary24h) {
        summary24h.classList.toggle('u-hidden', !option24h);
        if (summaryPrice24h) {
            summaryPrice24h.classList.toggle('u-hidden', tariffDetails.option24hIncluded);
        }
        if (summary24hIncluded) {
            summary24hIncluded.classList.toggle('u-hidden', !tariffDetails.option24hIncluded);
        }
    }
    const summaryFax = quickOrder.querySelector('.summary-fax');
    if (summaryFax) {
        summaryFax.classList.toggle('u-hidden', !optionFax);
    }
    const sumContainer = document.getElementById('summary-sum');
    if (sumContainer) {
        sumContainer.innerText = sum.toFixed(2).replace('.', window.prices.decimalPoint || ',');
    }
    const sumNoDecimalsContainer = document.getElementById('summary-sum-no-decimals');
    if (sumNoDecimalsContainer) {
        const decimalPoint = window.prices?.decimalPoint || ',';
        sumNoDecimalsContainer.innerText = sum.toLocaleString((typeof navigator.languages === 'object' && navigator.languages.length > 0) ? navigator.languages[0] : 'en-US').replace('.', decimalPoint);
    }
    const sumDate = document.getElementById('summary-date');
    if (sumDate) {
        sumDate.innerText = formatDate(startPaymentDate);
    }
};
const initQuickorderTariffsRadios = () => {
    const tariffRadios = document.querySelectorAll('input[name="tariff_c"]');
    tariffRadios.forEach(function (tariffRadio) {
        tariffRadio.addEventListener('change', updateTariffs);
    });
    const tariffOptions = document.querySelectorAll('.c-form--ps-phone-service-order input[name="24h"], .c-form--ps-phone-service-order input[name="fax"]');
    tariffOptions.forEach(function (tariffOption) {
        tariffOption.addEventListener('change', updateSummary);
    });
    updateTariffs();
};
export const initQuickorder = () => {
    document.readyState === 'loading'
        ? document.addEventListener('DOMContentLoaded', initQuickorderTariffsRadios)
        : initQuickorderTariffsRadios();
};
